export default class Statistics {
    /**
     * @param {Number}          id
     * @param {String}          colorName
     * @param {String}          colorCode
     * @param {String}          fandeckName
     * @param {String}          productName
     * @param {String}          baseName
     * @param {String}          packageName
     * @param {String}          bippPackageName
     * @param {Number}          dispensedPackageCount
     * @param {Number}          packageCount
     * @param {String}          customerName
     * @param {String}          colorRgb
     * @param {String}          timestampUtc
     * @param {Array}           customPackageName
     * @param {String}          moreInfo
     * @param {String}          moreInfoInternal
     * @param {Boolean}         hidden
     * @param {Number}          colorsStatsTypeId
     * @param {Boolean}         qualityControl
     * @param {String}          qualityControlDate
     * @param {Array | null}    colorants
     * @param {Array | null}    cumulativeColorants
     * @param {Array | null}    originalColorants
     * @param {String}          buildingSite
     * @param {String | null}   clientName
     */
    constructor(
        id,
        colorName,
        colorCode,
        fandeckName,
        productName,
        baseName,
        packageName,
        bippPackageName,
        dispensedPackageCount,
        packageCount,
        customerName,
        colorRgb,
        timestampUtc,
        customPackageName,
        moreInfo,
        moreInfoInternal,
        hidden,
        colorsStatsTypeId,
        qualityControl,
        qualityControlDate,
        colorants,
        cumulativeColorants,
        originalColorants,
        operator,
        buildingSite,
        clientName
    ) {
        this._id = id;
        this._colorName = colorName;
        this._colorCode = colorCode;
        this._fandeckName = fandeckName;
        this._productName = productName;
        this._baseName = baseName;
        this._packageName = packageName;
        this._bippPackageName = bippPackageName;
        this._dispensedPackageCount = dispensedPackageCount;
        this._packageCount = packageCount;
        this._customerName = customerName;
        this._colorRgb = colorRgb;
        this._timestampUtc = timestampUtc;
        this._customPackageName = customPackageName;
        this._moreInfo = moreInfo;
        this._moreInfoInternal = moreInfoInternal;
        this._hidden = hidden;
        this._colorsStatsTypeId = colorsStatsTypeId;
        this._qualityControl = qualityControl;
        this._qualityControlDate = qualityControlDate;
        this._colorants = colorants;
        this._cumulativeColorants = cumulativeColorants;
        this._originalColorants = originalColorants;
        this._operator = operator;
        this._buildingSite = buildingSite;
        this._clientName = clientName;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - Statistics");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get colorName() {
        return this._colorName;
    }

    /**
     * @param {String} colorName
     */
    set colorName(colorName) {
        this._colorName = colorName;
    }

    /**
     * @return {String}
     */
    get colorCode() {
        return this._colorCode;
    }

    /**
     * @param {String} colorCode
     */
    set colorCode(colorCode) {
        this._colorCode = colorCode;
    }

    /**
     * @return {String}
     */
    get fandeckName() {
        return this._fandeckName;
    }

    /**
     * @param {String} fandeckName
     */
    set fandeckName(fandeckName) {
        this._fandeckName = fandeckName;
    }

    /**
     * @return {String}
     */
    get productName() {
        return this._productName;
    }

    /**
     * @param {String} productName
     */
    set productName(productName) {
        this._productName = productName;
    }

    /**
     * @return {String}
     */
    get baseName() {
        return this._baseName;
    }

    /**
     * @param {String} baseName
     */
    set baseName(baseName) {
        this._baseName = baseName;
    }

    /**
     * @return {String}
     */
    get packageName() {
        return this._packageName;
    }

    /**
     * @param {String} packageName
     */
    set packageName(packageName) {
        this._packageName = packageName;
    }

    /**
     * @return {String}
     */
    get bippPackageName() {
        return this._bippPackageName;
    }

    /**
     * @param {String} bippPackageName
     */
    set bippPackageName(bippPackageName) {
        this._bippPackageName = bippPackageName;
    }

    /**
     * @return {Number}
     */
    get packageCount() {
        return this._packageCount;
    }

    /**
     * @param {Number} packageCount
     */
    set packageCount(packageCount) {
        this._packageCount = packageCount;
    }

    /**
     * @return {Number}
     */
    get dispensedPackageCount() {
        return this._dispensedPackageCount;
    }

    /**
     * @param {Number} dispensedPackageCount
     */
    set dispensedPackageCount(dispensedPackageCount) {
        this._dispensedPackageCount = dispensedPackageCount;
    }

    /**
     * @return {String}
     */
    get customerName() {
        return this._customerName;
    }

    /**
     * @param {String} customerName
     */
    set customerName(customerName) {
        this._customerName = customerName;
    }

    /**
     * @return {String}
     */
    get colorRgb() {
        return this._colorRgb;
    }

    /**
     * @param {String} colorRgb
     */
    set colorRgb(colorRgb) {
        this._colorRgb = colorRgb;
    }

    /**
     * @return {String}
     */
    get timestampUtc() {
        return this._timestampUtc;
    }

    /**
     * @param {String} timestampUtc
     */
    set timestampUtc(timestampUtc) {
        this._timestampUtc = timestampUtc;
    }

    /**
     * @return {Array}
     */
    get customPackageName() {
        return this._customPackageName;
    }

    /**
     * @param {Array} customPackageName
     */
    set customPackageName(customPackageName) {
        this._customPackageName = customPackageName;
    }

    /**
     * @return {String}
     */
    get moreInfo() {
        return this._moreInfo;
    }

    /**
     * @param {String} moreInfo
     */
    set moreInfo(moreInfo) {
        this._moreInfo = moreInfo;
    }

    /**
     * @return {String}
     */
    get moreInfoInternal() {
        return this._moreInfoInternal;
    }

    /**
     * @param {String} moreInfoInternal
     */
    set moreInfoInternal(moreInfoInternal) {
        this._moreInfoInternal = moreInfoInternal;
    }

    /**
     * @return {Boolean}
     */
    get hidden() {
        return this._hidden;
    }

    /**
     * @param {Boolean} hidden
     */
    set hidden(hidden) {
        this._hidden = hidden;
    }

    /**
     * @return {Number}
     */
    get colorsStatsTypeId() {
        return this._colorsStatsTypeId;
    }

    /**
     * @param {Number} colorsStatsTypeId
     */
    set colorsStatsTypeId(colorsStatsTypeId) {
        this._colorsStatsTypeId = colorsStatsTypeId;
    }

    /**
     * @return {Boolean}
     */
    get qualityControl() {
        return this._qualityControl;
    }

    /**
     * @return {String}
     */
    get qualityControlDate() {
        return this._qualityControlDate;
    }

    /**
     * @return {Array | null}
     */
    get colorants() {
        return this._colorants;
    }

    /**
     * @return {Array | null}
     */
    get cumulativeColorants() {
        return this._cumulativeColorants;
    }

    /**
     * @return {Array | null}
     */
    get originalColorants() {
        return this._originalColorants;
    }

    /**
     * @return {String | null}
     */
    get operator() {
        return this._operator;
    }

    /**
     * @return {String | null}
     */
    get buildingSite() {
        return this._buildingSite;
    }

    /**
     * @return {String | null}
     */
    get clientName() {
        return this._clientName;
    }
}
